// extracted by mini-css-extract-plugin
export default {"ManualKeyword":"manualKeyword_ManualKeyword__cLYgV"};